<template>
    <!-- Новий дизайн: своя мапа на MapLibre з підкладкою OpenFreeMap (як на lykhvar.com). Райони Луцька й села розфарбовані
         за вартістю доставки, клік показує умови. Ціни — з API наживо, межі — закодовані в src/data (не окремим файлом) -->
    <div v-if="$v2" class="bp-dmap">
        <BpPageNav title="Мапа доставки"/>
        <h1 class="bp-dmap__h1">Мапа доставки</h1>
        <p class="bp-dmap__lead">Возимо по Луцьку й найближчих селах. Натисни на район чи село — покажемо, скільки коштує доставка</p>

        <template v-if="hasMap">
            <div class="bp-dmap__box" :class="{ 'is-full': full }">
                <div ref="map" class="bp-dmap__map" @contextmenu.prevent></div>
                <div class="bp-dmap__mark" aria-hidden="true">pizza.black</div>

                <div class="bp-dmap__ctl bp-dmap__ctl--tl">
                    <button type="button" class="bp-dmap__btn" aria-label="Показати всю мапу" title="Показати всю мапу" @click="fitAll()" v-html="icons.home"></button>
                </div>
                <div class="bp-dmap__ctl bp-dmap__ctl--br">
                    <button type="button" class="bp-dmap__btn" aria-label="Наблизити" @click="map && map.zoomIn()" v-html="icons.plus"></button>
                    <button type="button" class="bp-dmap__btn" aria-label="Віддалити" @click="map && map.zoomOut()" v-html="icons.minus"></button>
                </div>
                <div class="bp-dmap__ctl bp-dmap__ctl--bl">
                    <button type="button" class="bp-dmap__btn" :aria-label="full ? 'Згорнути мапу' : 'Мапа на весь екран'" :title="full ? 'Згорнути мапу' : 'Мапа на весь екран'" @click="toggleFull()" v-html="full ? icons.minimize : icons.maximize"></button>
                </div>

                <div v-if="picked" class="bp-dmap__card" role="status">
                    <button type="button" class="bp-dmap__card-x" aria-label="Закрити" @click="pick(null)" v-html="icons.close"></button>
                    <!-- Однаково для всіх зон: «Населений пункт», назва, далі поля. Для районів міста — просто «Луцьк»: внутрішні назви
                         («33-й+40Б», «55-й») не показуємо; Липини, що в базі записані районом вулиць, — своєю назвою -->
                    <div class="bp-dmap__card-k">Населений пункт</div>
                    <div class="bp-dmap__card-h">{{ picked.kind == 'district' ? 'Луцьк' : picked.name }}</div>
                    <dl class="bp-dmap__terms">
                        <div><dt>Доставка</dt><dd>{{ range(picked.deliveryMin, picked.deliveryMax) }}</dd></div>
                        <div v-if="picked.freeMax"><dt>Безкоштовно від</dt><dd>{{ range(picked.freeMin, picked.freeMax) }}</dd></div>
                        <div><dt>Мінімальне замовлення</dt><dd>{{ range(picked.minMin, picked.minMax) }}</dd></div>
                    </dl>
                    <p v-if="picked.freeMin != picked.freeMax || picked.deliveryMin != picked.deliveryMax" class="bp-dmap__card-n">Точна сума залежить від вулиці — її видно в кошику</p>
                </div>

                <div v-if="failed" class="bp-dmap__fail">Мапа не завантажилась. Перевір інтернет і онови сторінку</div>
            </div>

            <div v-if="legend.length" class="bp-dmap__legend" aria-label="Вартість доставки">
                <span class="bp-dmap__legend-t">Доставка</span>
                <span v-for="item in legend" :key="item.tier" class="bp-dmap__chip"><i :style="{ background: item.color }"></i>{{ item.label }}</span>
                <span class="bp-dmap__chip"><i class="bp-dmap__chip-pin"></i>Black Pizza</span>
            </div>
            <p class="bp-dmap__note"><span class="bp-dmap__note-ic" v-html="icons.info"></span>Мінімальне замовлення й поріг безкоштовної доставки для своєї вулиці побачиш у кошику, коли введеш адресу</p>
        </template>

        <div v-else class="bp-dmap__box bp-dmap__box--frame">
            <iframe v-if="iframeSrc" :src="iframeSrc" title="Мапа доставки"></iframe>
        </div>
    </div>

    <div v-else style="margin-bottom: 140px">
        <div style="margin-bottom: 14px;text-align: left">
            <div class="page-title">
                Мапа доставки
            </div>
        </div>

        <div>
            <iframe v-if="iframeSrc" :src="iframeSrc" style="width: 100%; height: 500px"></iframe>

            <span v-if="!iframeSrc" style="color: #AB2321">Нажаль, для Вашого міста мапа недоступна</span>
        </div>
    </div>
</template>

<script>
import { ICONS } from '@/v2icons'
import BpPageNav from '@/components/BpPageNav.vue'

// MapLibre — лише на цій сторінці, з CDN, версія закріплена; підкладка OpenFreeMap (OpenStreetMap, без ключа)
const MAPLIBRE = 'https://unpkg.com/maplibre-gl@4.7.1/dist/maplibre-gl';
const STYLES = { light: 'https://tiles.openfreemap.org/styles/positron', dark: 'https://tiles.openfreemap.org/styles/dark' };
// Піцерія на Липинського, 7 — та сама точка, що й на карті доставки в адмінці (PagesController::DELIVERY_MAP_POINTS)
const PIZZERIA = [25.35786, 50.75366];
// Групи за вартістю доставки (грн): 30–35 · 50 · 70–80 · 100–150 · 200–250. Кольори різні (просив власник), підібрані
// валідатором палітр (скіл dataviz) так, щоб розрізнялись будь-які дві зони, що межують, — і при порушеннях кольорового зору.
// Світла: усі перевірки «всі пари» пройдено; темна: звичайний зір ≥ 18, CVD 7.1 — допустимо, бо є білі межі, легенда й картка
const TIER_EDGES = [40, 60, 90, 175];
const TIER_COLORS = {
    light: ['#1baf7a', '#eda100', '#2a78d6', '#e5502e', '#9b2d6f'],
    dark: ['#199e70', '#c9a000', '#3987e5', '#e2584f', '#b45cc0']
};
// Зони непрозорі, з кольором, заздалегідь змішаним із фоном підкладки (як напівпрозорі 0.5 / 0.82), і лежать під водою,
// будинками й дорогами — тоді «підбій» під згладженими межами не дає темних смуг, а вулиці видно поверх
const BASE_BG = { light: [242, 243, 240], dark: [12, 12, 12] };
const BASE_ALPHA = { light: .5, dark: .82 };
const mix = (hex, bg, a) => '#' + [1, 3, 5].map((i, k) => Math.round(parseInt(hex.slice(i, i + 2), 16) * a + bg[k] * (1 - a)).toString(16).padStart(2, '0')).join('');
// Межі закодовані алгоритмом polyline (точність 1e-4) — див. src/data/deliveryZonesLutsk.js
const ZONES = { lutsk: () => import(/* webpackChunkName: "delivery-zones-lutsk" */ '@/data/deliveryZonesLutsk.js') };
function decodeRing(str) {
    const ring = [];
    let i = 0, x = 0, y = 0;
    const next = () => {
        let shift = 0, value = 0, byte;
        do { byte = str.charCodeAt(i++) - 63; value |= (byte & 0x1f) << shift; shift += 5; } while (byte >= 0x20);
        return value & 1 ? ~(value >> 1) : value >> 1;
    };
    while (i < str.length) {
        y += next();
        x += next();
        ring.push([x / 1e4, y / 1e4]);
    }
    return ring;
}
// Межі районів зібрані з вулиць і кутасті — згладжуємо зрізанням кутів (Чайкін, 2 проходи)
function smooth(ring, passes = 2) {
    let pts = ring.slice(0, -1);
    for (let k = 0; k < passes; k++) {
        const next = [];
        pts.forEach((p, i) => {
            const q = pts[(i + 1) % pts.length];
            next.push([p[0] * .75 + q[0] * .25, p[1] * .75 + q[1] * .25], [p[0] * .25 + q[0] * .75, p[1] * .25 + q[1] * .75]);
        });
        pts = next;
    }
    return [...pts, pts[0]];
}
const decode = polys => polys.map(poly => poly.map(ring => smooth(decodeRing(ring))));

let maplibreLoading = null;
function loadMapLibre() {
    if (window.maplibregl) return Promise.resolve(window.maplibregl);
    if (!maplibreLoading) {
        maplibreLoading = new Promise((resolve, reject) => {
            const css = document.createElement('link');
            css.rel = 'stylesheet';
            css.href = MAPLIBRE + '.css';
            document.head.appendChild(css);
            const js = document.createElement('script');
            js.src = MAPLIBRE + '.js';
            js.onload = () => resolve(window.maplibregl);
            js.onerror = () => { maplibreLoading = null; reject(new Error('maplibre')); };
            document.head.appendChild(js);
        });
    }
    return maplibreLoading;
}

const tierOf = price => TIER_EDGES.filter(edge => price >= edge).length;
const span = values => [Math.min(...values), Math.max(...values)];

export default {
    components: { BpPageNav },

    data() {
        return {
            icons: ICONS,
            iframeSrc: '',
            map: null,
            features: null,
            picked: null,
            full: false,
            failed: false
        }
    },

    computed: {
        hasMap() {
            return !!ZONES[this.$route.params.locationCity];
        },

        // Легенда — лише групи, що є на мапі, з фактичними цінами в кожній
        legend() {
            if (!this.features) return [];
            return this.palette().map((color, tier) => {
                const prices = this.features.features.filter(f => f.properties.tier == tier).map(f => f.properties.deliveryMax);
                if (!prices.length) return null;
                const [a, b] = span(prices);
                return { tier, color, label: this.range(a, b) };
            }).filter(Boolean);
        }
    },

    watch: {
        '$store.state.nightMode'() {
            // diff: false — стиль перезавантажується повністю й шле style.load, де знову додаються зони й українські підписи
            if (this.map) this.map.setStyle(this.styleUrl(), { diff: false });
        }
    },

    methods: {
        range(a, b) {
            return a == b ? `${a} грн` : `${a}–${b} грн`;
        },

        theme() {
            return this.$store.state.nightMode ? 'dark' : 'light';
        },

        // Кольори зон такими, як їх видно на мапі, — і для легенди
        palette() {
            const t = this.theme();
            return TIER_COLORS[t].map(c => mix(c, BASE_BG[t], BASE_ALPHA[t]));
        },

        styleUrl() {
            return this.$store.state.nightMode ? STYLES.dark : STYLES.light;
        },

        // Райони — з вулиць бази (поле district), села — з міст; ціни лише доступних вулиць
        async buildFeatures() {
            const [zones, streets, cities] = await Promise.all([
                ZONES[this.$route.params.locationCity]().then(m => m.default),
                this.$store.dispatch('getStreets'),
                this.$store.dispatch('getCities')
            ]);
            const feature = (kind, name, rows, rings) => {
                const delivery = span(rows.map(r => +r.delivery_price)), free = span(rows.map(r => +r.free_delivery_price)), min = span(rows.map(r => +r.min_price));
                return {
                    type: 'Feature',
                    geometry: { type: 'MultiPolygon', coordinates: rings },
                    properties: { kind, name, tier: tierOf(delivery[1]), deliveryMin: delivery[0], deliveryMax: delivery[1], freeMin: free[0], freeMax: free[1], minMin: min[0], minMax: min[1] }
                };
            };
            const list = [];
            zones.v.forEach(([name, polys]) => {
                const city = cities.find(c => c.name == name);
                if (city) list.push(feature('village', name, [city], decode(polys)));
            });
            zones.d.forEach(([district, polys]) => {
                const rows = streets.filter(s => s.district == district && s.is_available == 1);
                // «Район», що насправді окремий населений пункт зі списку міст (Липини), — показуємо як село
                const place = cities.some(c => c.name == district && c.main != 1);
                if (rows.length) list.push(feature(place ? 'village' : 'district', district, rows, decode(polys)));
            });
            return { type: 'FeatureCollection', features: list };
        },

        bounds() {
            const b = [180, 90, -180, -90];
            this.features.features.forEach(f => f.geometry.coordinates.forEach(poly => poly[0].forEach(([x, y]) => {
                b[0] = Math.min(b[0], x); b[1] = Math.min(b[1], y); b[2] = Math.max(b[2], x); b[3] = Math.max(b[3], y);
            })));
            return [[b[0], b[1]], [b[2], b[3]]];
        },

        paddedBounds() {
            const [[w, s], [e, n]] = this.bounds(), dx = (e - w) * .6, dy = (n - s) * .6;
            return [[w - dx, s - dy], [e + dx, n + dy]];
        },

        fitAll() {
            if (this.map && this.features) this.map.fitBounds(this.bounds(), { padding: 32 });
        },

        // Наші шари — під підписами підкладки, щоб назви сіл і вулиць лишались читабельними
        addOverlay() {
            const map = this.map;
            // Підписи підкладки — лише українською (у стилі OpenFreeMap вони латиницею й кирилицею разом) і контрастні:
            // сірі назви вулиць на кольорових зонах губляться, тож світла тема — темні з білим обрисом, темна — навпаки
            const night = this.theme() == 'dark';
            map.getStyle().layers.forEach(layer => {
                const field = layer.layout && layer.layout['text-field'];
                if (!field || !JSON.stringify(field).includes('name')) return;
                map.setLayoutProperty(layer.id, 'text-field', ['coalesce', ['get', 'name:uk'], ['get', 'name']]);
                map.setPaintProperty(layer.id, 'text-color', night ? '#f1efea' : '#2b2b30');
                map.setPaintProperty(layer.id, 'text-halo-color', night ? '#1c1a1a' : '#ffffff');
                map.setPaintProperty(layer.id, 'text-halo-width', 1.5);
            });
            if (!this.features || map.getSource('zones')) return;
            // Заливка — під водою, будинками й дорогами; обвідка вибраної зони — одразу над останньою лінією підкладки
            // (у темному стилі перший підпис — назви водойм — стоїть ще до доріг, тож «перед першим підписом» не годиться)
            const layers = map.getStyle().layers, labels = layers.find(layer => layer.type == 'symbol');
            const under = layers.find(layer => layer.id == 'waterway') || labels;
            const lastLine = layers.map(layer => layer.type).lastIndexOf('line'), overLines = layers[lastLine + 1];
            const before = under ? under.id : undefined;
            map.addSource('zones', { type: 'geojson', data: this.features, generateId: true });
            const palette = this.palette(), color = ['match', ['get', 'tier']], strong = ['match', ['get', 'tier']];
            palette.forEach((c, i) => color.push(i, c));
            color.push(palette[0]);
            // Вибрана й підсвічена зона — трохи насиченіша, не повний колір: на ньому губляться назви вулиць
            const t = this.theme(), lift = TIER_COLORS[t].map(c => mix(c, BASE_BG[t], t == 'dark' ? .92 : .64));
            lift.forEach((c, i) => strong.push(i, c));
            strong.push(lift[0]);
            const dark = !!this.$store.state.nightMode;
            // «Підбій» кольору зони під заливкою: після згладжування між сусідніми районами лишаються щілини — він їх закриває
            map.addLayer({ id: 'zones-bleed', type: 'line', source: 'zones', layout: { 'line-join': 'round' }, paint: {
                'line-color': color,
                'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 12, 4, 14, 9]
            } }, before);
            map.addLayer({ id: 'zones-fill', type: 'fill', source: 'zones', paint: {
                'fill-color': ['case', ['any', ['boolean', ['feature-state', 'picked'], false], ['boolean', ['feature-state', 'hover'], false]], strong, color]
            } }, before);
            // Обвідка — лише при наведенні й виборі: постійні білі межі між районами двоїлись (сусідні райони не мають спільної лінії)
            map.addLayer({ id: 'zones-line', type: 'line', source: 'zones', layout: { 'line-join': 'round' }, paint: {
                'line-color': dark ? '#f1efea' : '#24242a',
                'line-width': ['case', ['boolean', ['feature-state', 'picked'], false], 2.5, ['boolean', ['feature-state', 'hover'], false], 1.5, 0],
                'line-opacity': ['case', ['boolean', ['feature-state', 'picked'], false], 1, .6]
            } }, overLines ? overLines.id : undefined);
            if (this.picked) map.setFeatureState({ source: 'zones', id: this.picked.id }, { picked: true });
        },

        pick(feature) {
            if (this.picked && this.map.getSource('zones')) this.map.setFeatureState({ source: 'zones', id: this.picked.id }, { picked: false });
            this.picked = feature ? { id: feature.id, ...feature.properties } : null;
            if (this.picked) this.map.setFeatureState({ source: 'zones', id: this.picked.id }, { picked: true });
        },

        toggleFull() {
            this.full = !this.full;
            document.body.style.overflow = this.full ? 'hidden' : '';
            this.$nextTick(() => this.map && this.map.resize());
        },

        onKey(e) {
            if (e.key == 'Escape' && this.full) this.toggleFull();
        },

        async initMap() {
            try {
                const [maplibregl, features] = await Promise.all([loadMapLibre(), this.buildFeatures()]);
                if (this._isDestroyed) return;
                this.features = features;
                const map = this.map = new maplibregl.Map({
                    container: this.$refs.map,
                    style: this.styleUrl(),
                    bounds: this.bounds(),
                    fitBoundsOptions: { padding: 32 },
                    // Лише околиці Луцька й не ближче рівня вулиць: мапа для вибору, а не для точного перемальовування меж
                    maxBounds: this.paddedBounds(),
                    minZoom: 9,
                    maxZoom: 14,
                    dragRotate: false,
                    touchPitch: false,
                    // Підпис джерел мапи прибрано на прохання власника (04.11) — ні на мапі, ні під нею
                    attributionControl: false,
                    cooperativeGestures: true,
                    locale: {
                        'CooperativeGesturesHandler.WindowsHelpText': 'Щоб змінити масштаб, тримай Ctrl і гортай',
                        'CooperativeGesturesHandler.MacHelpText': 'Щоб змінити масштаб, тримай ⌘ і гортай',
                        'CooperativeGesturesHandler.MobileHelpText': 'Пересувай мапу двома пальцями'
                    }
                });
                map.on('style.load', () => this.addOverlay());
                let hover = null;
                const setHover = id => {
                    if (hover !== null && map.getSource('zones')) map.setFeatureState({ source: 'zones', id: hover }, { hover: false });
                    hover = id;
                    if (hover !== null) map.setFeatureState({ source: 'zones', id: hover }, { hover: true });
                };
                map.on('mousemove', 'zones-fill', e => { map.getCanvas().style.cursor = 'pointer'; setHover(e.features[0].id); });
                map.on('mouseleave', 'zones-fill', () => { map.getCanvas().style.cursor = ''; setHover(null); });
                map.on('click', e => {
                    const hit = map.getSource('zones') ? map.queryRenderedFeatures(e.point, { layers: ['zones-fill'] }) : [];
                    this.pick(hit.length ? hit[0] : null);
                });
                const pin = document.createElement('div');
                pin.className = 'bp-dmap__pin';
                pin.title = 'Black Pizza — вул. Липинського, 7';
                new maplibregl.Marker({ element: pin }).setLngLat(PIZZERIA).addTo(map);
            } catch (e) {
                this.failed = true;
            }
        }
    },

    mounted() {
        // BASE_URL — «/» на сайті, «./» у демо-збірці під невідомим префіксом
        this.iframeSrc = process.env.BASE_URL + 'html/delivery-map/' + this.$route.params.locationCity + '.html';
        if (this.$v2 && this.hasMap) {
            window.addEventListener('keydown', this.onKey);
            this.initMap();
        }
    },

    beforeDestroy() {
        window.removeEventListener('keydown', this.onKey);
        if (this.full) document.body.style.overflow = '';
        if (this.map) this.map.remove();
    }
}
</script>
